import React, { createContext, useState } from 'react'
import { IInventoryResponse, IGetBusinessUnitResponse, TProductData, TGetStoReqResponse, RowStatus } from '../Models/Inventory';

export type IInventoryContext = {
  inventories: IInventoryResponse, setInventories: React.Dispatch<React.SetStateAction<IInventoryResponse>>,
  stoInventories: IInventoryResponse, setstoInventories: React.Dispatch<React.SetStateAction<IInventoryResponse>>,
  inventoriesStoRows: any, setInventoriesStoRows: React.Dispatch<React.SetStateAction<any>>,
  inventoriesStoLineItemsRows: any, setInventoriesStoLineItemsRows: React.Dispatch<React.SetStateAction<any>>,
  businessUnits: IGetBusinessUnitResponse[], setBusinessUnits: React.Dispatch<React.SetStateAction<IGetBusinessUnitResponse[]>>,
  products: TProductData[], setProducts: React.Dispatch<React.SetStateAction<TProductData[]>>,
  stockRequest: TGetStoReqResponse[], setStockRequest: React.Dispatch<React.SetStateAction<TGetStoReqResponse[]>>,
  externalLocation: IGetBusinessUnitResponse[], setExternalLocation: React.Dispatch<React.SetStateAction<IGetBusinessUnitResponse[]>>,
  rgpInventoryRows: any, setRGPInventoryRows: React.Dispatch<React.SetStateAction<any>>,
  rgpLineItems: any, setRGPLineItems: React.Dispatch<React.SetStateAction<any>>,
  getRGPCustomerAddress: any, setRGPCustomerAddress: React.Dispatch<React.SetStateAction<any>>,
}

export const InventoryContext = createContext<IInventoryContext>({} as IInventoryContext)

const IInventoryProvider = (props: any) => {

  const [inventories, setInventories] = useState<IInventoryResponse>({} as IInventoryResponse)
  const [stoInventories, setstoInventories] = useState<IInventoryResponse>({} as IInventoryResponse)
  const [businessUnits, setBusinessUnits] = useState<IGetBusinessUnitResponse[]>([] as IGetBusinessUnitResponse[])
  const [products, setProducts] = useState<TProductData[]>([] as TProductData[])
  const [stockRequest, setStockRequest] = useState<TGetStoReqResponse[]>([] as TGetStoReqResponse[])
  const [inventoriesStoRows, setInventoriesStoRows] = useState([])
  const [inventoriesStoLineItemsRows, setInventoriesStoLineItemsRows] = useState([]);
  const [externalLocation, setExternalLocation] = useState<IGetBusinessUnitResponse[]>([] as IGetBusinessUnitResponse[])

  const [rgpInventoryRows, setRGPInventoryRows] = useState([])
  const [rgpLineItems, setRGPLineItems] = useState([]);
  const [getRGPCustomerAddress, setRGPCustomerAddress] = useState([]);

  return (
    <InventoryContext.Provider
      value={{
        inventories, setInventories,
        stoInventories, setstoInventories,
        businessUnits, setBusinessUnits,
        products, setProducts,
        stockRequest, setStockRequest,
        inventoriesStoRows, setInventoriesStoRows,
        inventoriesStoLineItemsRows, setInventoriesStoLineItemsRows,
        externalLocation, setExternalLocation,
        rgpInventoryRows, setRGPInventoryRows,
        rgpLineItems, setRGPLineItems,
        getRGPCustomerAddress, setRGPCustomerAddress
      }}>
      {props.children}
    </InventoryContext.Provider>
  )
}

export default IInventoryProvider
